<template>
    <div class="assignment">
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Phiếu góp ý - báo cáo nội bộ (HR)
                <v-spacer></v-spacer> 
                
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>
                
                <v-divider vertical class="mx-4"></v-divider>

                <!-- <data-export v-model="exportDialog"></data-export> -->
                <v-btn v-if="selectedItems.length > 0" @click="bulkAccept" :loading="isBulkApproving" dark color="orange darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> 
                    <v-icon left>mdi-check-all</v-icon> DUYỆT ĐÃ CHỌN ({{ selectedItems.length }})
                </v-btn>
                <!-- <v-btn @click="dialog.state=true; item=undefined;" dark color="teal darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> <v-icon left>mdi-plus</v-icon> TẠO PHIẾU </v-btn> -->
            </v-card-title>
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <v-text-field label="Từ ngày" outlined type="date" v-model="filters.fromDate" hide-details dense
                    class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="background-color: white; min-width: 150px;"
                    ></v-text-field>

                    <v-text-field label="Đến ngày" outlined type="date" v-model="filters.toDate" hide-details dense
                    class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="background-color: white; min-width: 150px;"
                    ></v-text-field>

                    <v-text-field label="Mã phiếu" dense v-model="filters.id" outlined hide-details persistent-placeholder
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="background-color: white; min-width: 150px;" placeholder="TC..." ></v-text-field>
                        
                    <v-select label="Trạng thái" placeholder="Chọn" dense v-model="filters.status" outlined hide-details
                        :items="[
                            {text: 'Tất cả', value: -1},
                            {text: 'Phiếu mới', value: 0},
                            {text: 'Đã xử lý', value: 1},
                            {text: 'Từ chối', value: 2},
                        ]"
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 150px; background-color: white;" ></v-select>
 
                    <div style="flex-basis: 100%; height: 0;"></div>

                    <!-- <v-text-field label="Mã NS" placeholder="NS0000" dense v-model="filters.employeeCode" outlined hide-details persistent-placeholder
                    class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="background-color: white; min-width: 150px;"></v-text-field>
                        
                    <v-text-field label="Tên NS" dense v-model="filters.employeeName" outlined hide-details persistent-placeholder placeholder="Trần Văn A"
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="background-color: white; min-width: 150px;"></v-text-field>
                        
                    <v-autocomplete label="Phòng ban" clearable outlined :items="departments.map(x=>{
                            return {
                                text: x.name,
                                value: x.code
                            }
                        })" v-model="filters.departmentCode" dense hide-details persistent-placeholder
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 250px; background-color: white;"></v-autocomplete>

                    <v-text-field label="Từ khóa" clearable dense v-model="filters.search" outlined hide-details persistent-placeholder placeholder="Ghi chú, từ khóa..."
                        class="mx-2 my-2 flex-grow-1 flex-shrink-1" style="min-width: 250px; background-color: white;"></v-text-field> -->
                </div>
            </v-sheet>
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Đã duyệt: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                     Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>
            <v-data-table
            v-model="selectedItems"
            item-key="id"
            :mobile-breakpoint="0"
            height="600px" fixed-header
            :headers="headers"
            :items="items"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            :footer-props="{
                itemsPerPageOptions:[
                50, 100, 200
                ]
            }"
            >
                <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-simple-checkbox v-if="item.status === 0" :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                </template>

                <template v-slot:[`item.anonymousType`]="{item}">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">
                        <span v-if="item.anonymousType === true || item.anonymousType == 1" class="font-italic grey--text">Ẩn danh</span>
                        <span v-else>{{ item.createdBy }}</span>
                    </div>
                    <div class="caption grey--text mt-1" v-if="item.createdAt">{{ formatTime(item.createdAt) }}</div>
                </template>

                <template v-slot:[`item.from`]="{item}">
                     <span v-if="item.from">{{formatDate(item.from)}}</span>
                </template>

                <template v-slot:[`item.detail`]="{item}">
                     <div v-html="item.detail" class="py-2"></div>
                </template>

                <template v-slot:[`item.expectation`]="{item}">
                     <div v-html="item.expectation" class="py-2"></div>
                </template>

                <template v-slot:[`item.attachment`]="{item}">
                    <div class="d-flex flex-wrap pt-2">
                        <v-avatar size="40" class="mr-1 mb-1" style="cursor: pointer; border: 1px solid #e0e0e0;" v-if="item.image1" @click="openMedia(item.image1, 'image')">
                            <v-img :src="item.image1"></v-img>
                        </v-avatar>
                        <v-avatar size="40" class="mr-1 mb-1" style="cursor: pointer; border: 1px solid #e0e0e0;" v-if="item.image2" @click="openMedia(item.image2, 'image')">
                            <v-img :src="item.image2"></v-img>
                        </v-avatar>
                        <v-avatar size="40" class="mr-1 mb-1" style="cursor: pointer; border: 1px solid #e0e0e0;" v-if="item.image3" @click="openMedia(item.image3, 'image')">
                            <v-img :src="item.image3"></v-img>
                        </v-avatar>
                        <v-avatar size="40" class="mr-1 mb-1" style="cursor: pointer; border: 1px solid #e0e0e0;" v-if="item.image4" @click="openMedia(item.image4, 'image')">
                            <v-img :src="item.image4"></v-img>
                        </v-avatar>
                        <v-avatar size="40" class="mr-1 mb-1 grey lighten-3" style="cursor: pointer; border: 1px solid #e0e0e0;" v-if="item.video" @click="openMedia(item.video, 'video')">
                            <v-icon color="red">mdi-play-circle</v-icon>
                        </v-avatar>
                        <span class="caption grey--text mt-2" v-if="!item.image1 && !item.image2 && !item.image3 && !item.image4 && !item.video">Không có</span>
                    </div>
                </template>
                
                <template v-slot:[`item.processInfo`]="{item}">
                    <div v-if="item.sentDate" style="line-height: 1.3;"><span class="grey--text caption">Gửi:</span> {{formatDate(item.sentDate)}}</div>
                    <div v-if="item.confirmBy && item.status != 0" style="line-height: 1.3;"><span class="grey--text caption">Duyệt:</span> {{item.confirmBy}}</div>
                    <div v-if="item.confirmDate && item.status != 0" style="line-height: 1.3;"><span class="grey--text caption">Lúc:</span> {{formatDate(item.confirmDate)}}</div>
                </template>

                <template v-slot:[`item.actions`]="{item}" >
                    <!-- ********* Edit ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 green--text text--darken-3 font-weight-bold" color="green lighten-4" @click="accept(item)">
                        <v-icon left small>mdi-check-circle</v-icon> Duyệt
                    </v-btn>

                    <!-- ********* Xoa ****** -->
                    <v-btn x-small depressed rounded v-if="item.status == 0 && !isLoading" class="mx-1 my-1 red--text text--darken-3 font-weight-bold" color="red lighten-4" @click="decline(item)" >
                        <v-icon left small>mdi-close-circle</v-icon> Từ chối
                    </v-btn>

                    <!-- ********* Undo ****** -->
                    <v-btn x-small depressed rounded class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" v-if="item.status != 0 && !isLoading" color="blue-grey lighten-4" @click="undo(item)" >
                        <v-icon left small>mdi-undo</v-icon> Hoàn tác
                    </v-btn>
                    
                    <!-- <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="remove(item)" v-if="item.status == 0">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn> -->
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="$helper.formatStatus(item.status).color" small dark style="width: 100px; justify-content: center;">
                        {{$helper.formatStatus(item.status).text}}
                    </v-chip>
                </template>
                <template v-slot:[`item.departmentName`]="{ item }">
                    <v-chip class="ma-2 caption font-weight-bold" color="teal darken-4" label text-color="white" v-if="item.departmentName">
                    <v-icon left>
                        mdi-store
                    </v-icon>
                    {{item.departmentName}}
                    </v-chip>
                </template>
                <template v-slot:[`item.confirmDate`]="{ item }" >
                    {{item.confirmDate}}
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** MEDIA VIEWER *************** -->
        <v-dialog v-model="mediaDialog" max-width="800px">
            <v-card class="rounded-xl">
                <v-card-title class="headline">Tệp đính kèm
                    <v-spacer></v-spacer>
                    <v-btn icon @click="mediaDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="d-flex flex-column align-center justify-center pb-6">
                    <template v-if="currentMedia.type === 'image'">
                        <v-img :src="currentMedia.url" max-width="100%" max-height="70vh" contain class="rounded-lg"></v-img>
                    </template>
                    <template v-else-if="currentMedia.type === 'video'">
                        <video :src="currentMedia.url" controls autoplay style="max-width: 100%; max-height: 70vh; border-radius: 8px;"></video>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import ApiServices from '@/components/services/ApiServices';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import * as moment from "moment/moment";
import * as api from './api.js';

export default {
    name: "InternalDenouceHr",
    components: {
        myBreadCrumb,
        'data-filter': DataFilter,
    },
    props: ["breadcrumbs", "icon"],
    watch: {
        tableParams: {
            handler (val) {
                console.log(this.tableParams,"////////");
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },
    },
    computed: {
        pendingCount() {
            return this.items.filter((item) => item.status === 0).length;
        },
        confirmedCount() {
            return this.items.filter((item) => item.status === 1).length;
        },
        rejectedCount() {
            return this.items.filter((item) => item.status === 2).length;
        },
        totalCount() {
            return this.items.length;
        }
    },
    data () {
        return {
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize:50
            },
            filters:{
                id: null,
                status: -1,
                employeeCode: null,
                employeeName: null,
                departmentCode: null,
                departmentName: null,
                search: null,
                fromDate: moment().startOf("year").format("YYYY-MM-DD"),
                toDate: moment().endOf("year").format("YYYY-MM-DD")
            },
            departmentSearch:null,
            departments: [],
            rowCount: 0,
            
            //DATA TABLE
            totalItem: 0,
            items: [],
            selectedItems: [],
            isBulkApproving: false,
            search:"",
            options: {},
            isLoading: true,

            dialog: {
                state: false,
                item: undefined,
            },
            item: null,
            dialogDelete: false,
            targetItem: undefined,
            
            mediaDialog: false,
            currentMedia: {
                type: 'image',
                url: ''
            },

            headers: [
                { text: 'Thao tác', value: 'actions', width: '8rem'},
                { text: 'Mã', value: 'id', width: '5rem', 
                    filter: value => {
                    if (!this.filters.id) return true
                    return value == this.filters.id
                    },
                },
                { text: 'Trạng thái', align: 'start', value: 'status', sortable: true, width: '6rem',
                    filter: value => {
                    if (this.filters.status==-1) return true
                    return value == (this.filters.status)
                    },
                },
                { text: 'Người gởi', align: 'start', value: 'anonymousType', width: '10rem'},
                { text: '', align: ' d-none', value: 'employeeCode', 
                    filter: value => {
                    if (!this.filters.employeeCode) return true
                    return value?.includes(this.filters.employeeCode)
                    },
                },
                { text: '', align: ' d-none', value: 'employeeName', 
                    filter: value => {
                    if (!this.filters.employeeName) return true
                    return value?.toLowerCase().includes(this.filters.employeeName.toLowerCase())
                    },
                },
                { text: '', align: ' d-none', value: 'departmentCode', 
                    filter: value => {
                    if (!this.filters.departmentCode) return true
                    return value == (this.filters.departmentCode)
                    },
                },
                { text: 'Nội dung', align: 'start', value: 'detail', width: '25rem', 
                    filter: value => true,
                },
                { text: 'Hướng xử lý', align: 'start', value: 'expectation', width: '20rem', 
                    filter: value => true,
                },
                { text: 'Đính kèm', align: 'start', value: 'attachment', width: '12rem', sortable: false },
                { text: 'createdAt', align: ' d-none', value: 'createdAt', width: '11rem'},
                { text: '', align: ' d-none', value: 'sentDate'},
                // { text: 'Ghi chú', align: 'start', value: 'note', width: '15rem',
                //     filter: value => {
                //     if (!this.filters.search) return true
                //     return value?.toLowerCase().includes(this.filters.search.toLowerCase())
                //     },
                // },
                { text: '', align: ' d-none', value: 'confirmBy'},
                { text: '', align: ' d-none', value: 'confirmDate'},
            ],
        }
    },
    methods: {
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        formatTime(value) {
            if (!value) return "";
            return moment(value).format("DD/MM/YYYY HH:mm");
        },
        openMedia(url, type) {
            this.currentMedia = { url, type };
            this.mediaDialog = true;
        },
        fetchDepartment() {
            http.get("departments/fetch").then(res => {
                this.departments = res.data;
            })
        },
        fetchData () {
            this.isLoading = true;
            api.fetchList({
                fromDate: this.filters.fromDate,
                toDate: this.filters.toDate
            })
            .then(res => {
                this.items = res.data?.data || res.data || [];
            })
            .catch(err => {
                console.error(err);
                this.items = [];
            })
            .finally(() => {
                this.isLoading = false;
            })
        },
        accept(item) {
            this.isLoading = true;
            api.accept(item.code || item.id).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err);
                this.isLoading = false;
            });
        },
        bulkAccept() {
            if (this.selectedItems.length === 0) return;
            this.isBulkApproving = true;
            const itemsToApprove = this.selectedItems.filter(item => item.status === 0);
            
            let promise = Promise.resolve();
            itemsToApprove.forEach(item => {
                promise = promise.then(() => {
                    return api.accept(item.code || item.id).catch(error => {
                        console.error("Error accepting item: ", error);
                    });
                });
            });
            
            promise.finally(() => {
                this.isBulkApproving = false;
                this.selectedItems = [];
                this.fetchData();
            });
        },
        decline(item) {
            this.isLoading = true;
            api.decline(item.code || item.id).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err);
                this.isLoading = false;
            });
        },
        undo(item) {
            this.isLoading = true;
            api.undo(item.code || item.id).then(res => {
                this.fetchData();
            }).catch(err => {
                console.log(err);
                this.isLoading = false;
            });
        },
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            api.deleteItem(this.targetItem.code || this.targetItem.id).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            })
        },
    },
    created () {
        this.fetchData();
        this.fetchDepartment()
    }
}
</script>
